import React, {useState} from 'react';
import {Container, Collapse, Navbar, NavbarToggler, Nav, NavItem, NavLink} from 'reactstrap';
import FacebookLikeButton from 'components/Social/FacebookLikeButton';
import ShareButtons from 'components/Social/ShareButtons';
import classNames from 'classnames';
import './Header.scss';

export default function Header({
  logoUrl = 'https://cdn.foodrevolution.org/hhc/frn-hhm-logo-lockup-white.svg',
  logoAlt = 'FRN logo lockup with Healthy Heart Masterclass logo',
  logoWidth = 300,
  logoHeight = 58,
  bgColor = 'purple',
  textColor = 'white',
  className = undefined,
  ...props
}) {
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => setCollapsed(!collapsed);
  return (
    <header
      className={classNames(`header`, `background-${bgColor}`, `text-${textColor}`, `d-flex`, `flex-column`, className)}
    >
      <Container className={classNames(`headerContainer`, `my-auto`)}>
        <Navbar className={classNames(`headerNavbar`, `p-0`)} expand="lg" container={false}>
          <div className={classNames(`headerNavbarBrand`, `flex-grow-1`)}>
            <img
              className={classNames(`headerLogo`)}
              alt={logoAlt}
              src={logoUrl}
              width={logoWidth}
              height={logoHeight}
            />
          </div>

          <div className="d-flex align-items-center fb-wrap mr-sm-2" style={{maxHeight: '50px'}}>
            <div className="d-none d-lg-inline mr-1">
              <ShareButtons {...props} noDescription />
            </div>
            <FacebookLikeButton />
          </div>

          <NavbarToggler onClick={toggleNavbar} />

          <Collapse
            className={classNames(`headerCollapse`, `mt-2`, `mt-lg-0`, `flex-grow-0`)}
            isOpen={!collapsed}
            navbar
          >
            <Nav navbar>
              <NavItem>
                <NavLink href="https://support.foodrevolution.org/" target="_blank">
                  Support
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://community.foodrevolution.org/" target="_blank">
                  Login
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    </header>
  );
}
